import React from "react";
import { Paragraph } from "@sicredi/react";
import styles from "./styles.module.scss";
import { IFooter } from "./model";

export const Footer: React.FC<IFooter> = ({
  paddingBottomMobile = false,
  paddingMobile = false,
}) => {
  return (
    <div
      data-testid="footer-jest"
      className={
        paddingBottomMobile
          ? styles.padding_bottom_mobile
          : paddingMobile
          ? styles.padding_mobile
          : styles.container
      }
    >
      <div className={styles.line} />
      <Paragraph size="x-small" className={styles.text}>
        Os valores apresentados podem sofrer alterações, e a disponibilidade
        está condicionada às vagas nos grupos e capacidade de pagamento. Os
        direitos e obrigações do consorciado e da Administradora de Consórcios
        Sicredi Ltda, além das características dos planos e grupos de
        consórcios, estão definidos no Regulamento Geral. Para mais informações,
        consulte sua cooperativa de crédito. Para cancelar seu consórcio, entre
        em contato com a central de atendimento no 0800 724 47 70.
      </Paragraph>
    </div>
  );
};
